export class MessageResponseModel {
  public constructor(public readonly payload: MessageResponseModel) {}
}
